import React from 'react';
import Course from 'views/Course';
import CourseLayout from 'layouts/CourseLayout';
import WithLayout from 'WithLayout';

const CoursePage = ({pageContext, children}) => (
  <WithLayout component={Course} layout={CourseLayout} pageContext={pageContext}>
    {children}
  </WithLayout>
);

export default CoursePage;
